import { IStoreEntityStateSlice, createEntitySlice } from '@aston/foundation';
import { NewAccountStep } from 'apps/console/src/app/account-module/enums/new-account-step.enum';
import { ISubsidiaryBlockedForm, ISubsidiaryForm, ISubsidiaryFromLegalIdentifier, ISubsidiaryListItem } from 'apps/console/src/app/subsidiaries-module/models';

export interface INewAccountState {
	creationCanceled: boolean;
	currentStep: NewAccountStep;
	selectedSubsidiary: IStoreEntityStateSlice<ISubsidiaryListItem>;
	subsidiaryForm: IStoreEntityStateSlice<ISubsidiaryForm>;
	subsidiaryBlockedForm: IStoreEntityStateSlice<ISubsidiaryBlockedForm>;
	subsidiaryFromLegalIdentifier: IStoreEntityStateSlice<ISubsidiaryFromLegalIdentifier>;
	subscriptionForm: IStoreEntityStateSlice<void>;
	isSubsidiaryInitialized: boolean;
}

export const initialState: INewAccountState = {
	creationCanceled: false,
	currentStep: NewAccountStep.Company,
	selectedSubsidiary: createEntitySlice(),
	subsidiaryForm: createEntitySlice(),
	subsidiaryBlockedForm: createEntitySlice(),
	subsidiaryFromLegalIdentifier: createEntitySlice(),
	subscriptionForm: createEntitySlice(),
	isSubsidiaryInitialized: false
};
